import { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { userService } from '../../services/api';
import { Input, Select, Button, Toast } from '../../components/ui';

const CreateUserForm = ({ roles, retailOUs, courses, onClose, onCreated }) => {
  const { dark } = useTheme();
  const { user: currentUser } = useAuth();
  const isRetailOULead = currentUser?.role?.code === 'RETAIL_OU_LEAD';

  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', employeeId: '',
    role: '', retailOU: '', phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  // Pre-select COUNSELLOR as the default role once the roles list is available
  useEffect(() => {
    if (roles.length && !form.role) {
      const counsellor = roles.find(r => r.code === 'COUNSELLOR');
      if (counsellor) setForm(prev => ({ ...prev, role: counsellor._id }));
    }
  }, [roles]);

  const selectedRole = roles.find(r => r._id === form.role);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.firstName || !form.email) {
      setToast({ msg: 'First name and email are required', type: 'error' });
      return;
    }
    setLoading(true);
    try {
      const { data } = await userService.create(form);
      const emailNote = data?.data?.emailSent === false ? ' (credentials email failed — check server logs)' : ' — credentials sent to their email';
      setToast({ msg: `User created successfully${emailNote}`, type: 'success' });
      if (onCreated) onCreated();
      setTimeout(onClose, 1500);
    } catch (err) {
      setToast({ msg: err.response?.data?.message || err.message || 'Error creating user', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const f = (field) => ({ value: form[field], onChange: e => setForm({ ...form, [field]: e.target.value }) });

  return (
    <div>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
          <Input label="First Name *" {...f('firstName')} placeholder="Enter first name" />
          <Input label="Last Name" {...f('lastName')} placeholder="Enter last name" />
          <Input label="Email *" {...f('email')} placeholder="Enter email" type="email" />
          <Input label="Employee ID" {...f('employeeId')} placeholder="e.g. EMP001" />
          <Input label="Phone" {...f('phone')} placeholder="Enter phone" />
          {!isRetailOULead && (
            <Select label="Role *" {...f('role')} options={roles.map(r => ({ value: r._id, label: r.name }))} />
          )}
          {!isRetailOULead && (selectedRole?.code === 'RETAIL_OU_LEAD' || selectedRole?.code === 'COUNSELLOR') && (
            <Select label="Retail OU" {...f('retailOU')} options={retailOUs.map(o => ({ value: o._id, label: o.name }))} />
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
          <Button variant="outline" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={loading}>Create User</Button>
        </div>
      </form>
    </div>
  );
};

export default CreateUserForm;
